var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
import { createAsyncThunk } from '@reduxjs/toolkit';
import { removeCommunityToken, setCommunityToken } from 'src/helpers/token';
import { unsubscribeWebPush } from 'src/helpers/webpush';
import { UserRole } from 'src/types/user';
import API from '../../../api';
import { LOCAL_STORAGE_KEYS } from '../../../common/localStorageKeys';
import { tryParseJSON } from '../../../common/utils/jsonUtils';
import { localStorageWrapper } from '../../../helpers/storageFactory';
import { createAsyncSlice } from '../sliceCreator';
export function getInitState() {
    var token = tryParseJSON(localStorageWrapper.getItem(LOCAL_STORAGE_KEYS.COMMUNTY_ACCOUNT_TOKEN));
    return {
        isAutorized: !!token,
        accountInfo: null,
        isLoading: !!token,
        prevPath: null,
    };
}
var accountSlice = createAsyncSlice({
    name: 'communityAccount',
    initialState: getInitState(),
    reducers: function (create) { return ({
        register: create.asyncThunk(function (data_1, _a) { return __awaiter(void 0, [data_1, _a], void 0, function (data, _b) {
            var response;
            var rejectWithValue = _b.rejectWithValue;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, API.community.account.register(data)];
                    case 1:
                        response = _c.sent();
                        if (response.success) {
                            setCommunityToken(response.data.token);
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, rejectWithValue({ success: false })];
                }
            });
        }); }),
        googleAuth: create.asyncThunk(function (data_1, _a) { return __awaiter(void 0, [data_1, _a], void 0, function (data, _b) {
            var response;
            var rejectWithValue = _b.rejectWithValue;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, API.community.account.googleAuth(data)];
                    case 1:
                        response = _c.sent();
                        if (response.success) {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, rejectWithValue({ success: false })];
                }
            });
        }); }, {
            fulfilled: function (state, action) {
                if (action.payload.success) {
                    setCommunityToken(action.payload.data.token);
                }
            },
        }),
        getAccountInfo: create.asyncThunk(function (data_1, _a) { return __awaiter(void 0, [data_1, _a], void 0, function (data, _b) {
            var response;
            var rejectWithValue = _b.rejectWithValue;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, API.community.account.getAccountInfo(data)];
                    case 1:
                        response = _c.sent();
                        if (response.success) {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, rejectWithValue({ success: false })];
                }
            });
        }); }, {
            fulfilled: function (state, action) {
                state.accountInfo = action.payload.data.account;
                state.isLoading = false;
                state.isAutorized =
                    (action.payload.data.account.subjects && action.payload.data.account.subjects.length > 0) ||
                        action.payload.data.account.roleKey === UserRole.UnivercityAdmin;
            },
        }),
        resetState: create.reducer(function () {
            removeCommunityToken();
            return {
                accountInfo: null,
                isAutorized: false,
                isLoading: false,
                prevPath: null,
            };
        }),
        updateCommunityToken: create.asyncThunk(function (newAccessToken) {
            setCommunityToken(newAccessToken);
            return newAccessToken != null;
        }, {
            fulfilled: function (state, action) {
                state.isLoading = false;
                state.isAutorized = action.payload;
                state.prevPath = null;
            },
        }),
    }); },
    extraReducers: function (builder) {
        builder.addCase(communityLogout.fulfilled, function (state, action) {
            state.accountInfo = null;
            state.isAutorized = false;
            state.isLoading = false;
            state.prevPath = action.payload;
        });
    },
    selectors: {
        selectIsAutorized: function (state) { return state.isAutorized; },
        selectIsLoading: function (state) { return state.isLoading; },
        selectMyId: function (state) { var _a; return (_a = state.accountInfo) === null || _a === void 0 ? void 0 : _a.id; },
        selectMyRole: function (state) { var _a; return (_a = state.accountInfo) === null || _a === void 0 ? void 0 : _a.roleKey; },
        selectPrevPath: function (state) { return state.prevPath; },
        selectIsPlatformPrivacyPolicyAccepted: function (state) { var _a, _b; return (_b = (_a = state.accountInfo) === null || _a === void 0 ? void 0 : _a.platformPrivacyPolicyAccepted) !== null && _b !== void 0 ? _b : true; },
    },
});
export var register = (_a = accountSlice.actions, _a.register), getAccountInfo = _a.getAccountInfo, googleAuth = _a.googleAuth, updateCommunityToken = _a.updateCommunityToken, resetState = _a.resetState;
export var selectIsAutorized = (_b = accountSlice.selectors, _b.selectIsAutorized), selectIsLoading = _b.selectIsLoading, selectMyId = _b.selectMyId, selectMyRole = _b.selectMyRole, selectPrevPath = _b.selectPrevPath, selectIsPlatformPrivacyPolicyAccepted = _b.selectIsPlatformPrivacyPolicyAccepted;
export var communityLogout = createAsyncThunk('account/communityLogout', function () {
    removeCommunityToken();
    unsubscribeWebPush();
    var prevPath = window.location.pathname + window.location.search;
    return prevPath == '/' || prevPath == '' ? null : prevPath;
});
export default accountSlice.reducer;
